import {
  PROPERTY_CATEGORIES as FORM_CATEGORIES,
  CATEGORY_LABELS,
  FURNISHED_OPTIONS as FORM_FURNISHED,
  FACING_OPTIONS as FORM_FACING,
  PARKING_TYPE_OPTIONS as FORM_PARKING_TYPE,
  RENTAL_PAYMENT_FREQUENCY_OPTIONS as FORM_PAYMENT_FREQ,
  RENTAL_INCLUDED_EXPENSES_OPTIONS as FORM_RENT_EXPENSES,
  ADMINISTRATION_TYPE_OPTIONS as FORM_ADMIN_TYPE,
  CONDO_INCLUDED_EXPENSES_OPTIONS as FORM_CONDO_EXPENSES,
  TRANSACTION_TYPES as FORM_TRANSACTIONS,
  CONDO_SECURITY as FORM_CONDO_SECURITY,
} from '@/features/property-management/components/PropertyFormDualPane/schema.constants';

export const BRAZILIAN_STATES = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

/**
 * Filter options: every stored category and transaction, the Univen values
 * included. The property form's own option lists (PropertyFormDualPane)
 * gain them with the form redesign; a filter has to find what is already
 * stored. Temporada is short-term letting, never a kind of Aluguel.
 */
export const PROPERTY_CATEGORIES: string[] = [...new Set<string>([...FORM_CATEGORIES, 'Pousada', 'Academia', 'Edifício'])];
export { CATEGORY_LABELS };
export const TRANSACTION_TYPES: string[] = [...new Set<string>([...FORM_TRANSACTIONS, 'Temporada', 'Leilão'])];

export const FURNISHED_OPTIONS = [...FORM_FURNISHED];
export const FACING_OPTIONS = [...FORM_FACING];
export const PARKING_TYPE_OPTIONS = [...FORM_PARKING_TYPE];
export const PAYMENT_FREQUENCY_OPTIONS = [...FORM_PAYMENT_FREQ];
export const RENT_INCLUDED_EXPENSES_OPTIONS = [...FORM_RENT_EXPENSES];
export const ADMINISTRATION_TYPE_OPTIONS = [...FORM_ADMIN_TYPE];
export const CONDO_EXPENSES_OPTIONS = [...FORM_CONDO_EXPENSES];

export const RENT_GUARANTEE_OPTIONS = ['deposit', 'guarantor', 'insurance', 'capitalization'] as const;

export const AMENITIES_INTERNAL_OPTIONS = [
  'air_conditioning', 'built_in_closets', 'jacuzzi',
  'fireplace', 'furnished', 'garage',
] as const;
export const AMENITIES_EXTERNAL_OPTIONS = [
  'pool', 'barbecue', 'gourmet_space', 'playground',
  'party_room', 'game_room', 'gym', 'toy_library',
  'sports_court', 'pet_place', 'garden', 'sauna',
] as const;
export const AMENITIES_SECURITY_OPTIONS = [
  'reception_24h', 'cameras', 'alarm', 'electric_fence',
  'security_circuit', 'guard_house', 'intercom',
] as const;
export const CONDO_LEISURE_OPTIONS = [
  'pool', 'gym', 'playground', 'party_room',
  'barbecue', 'sauna', 'gourmet_space', 'toy_library',
  'sports_court', 'pet_place', 'cinema_room',
] as const;
export const CONDO_SECURITY_OPTIONS = [...FORM_CONDO_SECURITY];

export interface PropertyFilters {
  /** Narrows the listing to the signed-in broker's own starred listings. */
  favorites?: boolean;
  /** Narrows to listings created via spreadsheet import, any session. */
  imported?: boolean;
  state?: string;
  city?: string;
  neighborhood?: string;
  categories?: string[];
  transactions?: string[];
  priceMinSale?: string;
  priceMaxSale?: string;
  priceMinRent?: string;
  priceMaxRent?: string;
  bedrooms?: string;
  bathrooms?: string;
  parking?: string;
  suites?: string;
  areaBuiltMin?: string;
  areaBuiltMax?: string;
  areaTotalMin?: string;
  areaTotalMax?: string;
  condoFeeMin?: string;
  condoFeeMax?: string;
  condoPaymentFrequency?: string;
  petFriendly?: boolean;
  furnished?: string;
  hasVirtualTour?: boolean;
  facing?: string;
  exchange?: boolean;
  yearBuiltMin?: string;
  yearBuiltMax?: string;
  floorMin?: string;
  floorMax?: string;
  totalRooms?: string;
  amenitiesInternal?: string[];
  amenitiesExternal?: string[];
  amenitiesSecurity?: string[];
  condoLeisure?: string[];
  condoSecurity?: string[];
  condoExpenses?: string[];
  rentPaymentFrequency?: string;
  rentGuarantee?: string[];
  rentIncludedExpenses?: string[];
  leaseTermMonths?: string;
  administrationType?: string;
  parkingType?: string[];
}
